import dayjs from 'dayjs';
import { formatThousandUnitDefaultTwo, keepTwoOrNull } from '@/utils/utils';
import { TrendDataPoint } from '../../hooks/useOverallTrend';

export const getBarChartOption = (
  data: TrendDataPoint[],
  color: string,
  yAxisName: string,
  formatTime: string,
  unit: string
) => {
  const displayUnit = unit?.trim();
  const tooltipUnit = displayUnit?.toLowerCase() === 'ph' ? '' : displayUnit;

  return {
    tooltip: {
      trigger: 'axis',
      formatter: (params: any) => {
        const list = Array.isArray(params) ? params : [params];
        const title = list[0]?.axisValue ?? '';
        const lines = list.map(item => {
          const value = formatThousandUnitDefaultTwo(item.value);
          return `${item.marker ?? ''}${item.seriesName ?? ''}: ${value}${tooltipUnit ?? ''}`;
        });

        return [title, ...lines].filter(Boolean).join('<br/>');
      },
    },
    grid: {
      left: 50,
      right: 10,
      top: 40,
      bottom: 10,
      containLabel: true,
    },
    legend: {
      right: 10,
      top: 0,
      itemWidth: 12,
      itemHeight: 12,
    },
    xAxis: {
      data: data.map(d => dayjs(d.time, 'x').format(formatTime)),
    },
    yAxis: {
      type: 'value',
      name: `${yAxisName}(${unit})`,
    },
    series: [
      {
        name: yAxisName,
        type: 'bar',
        data: data.map(d => keepTwoOrNull(d.value)),
        itemStyle: { color },
        barMaxWidth: 24,
      },
    ],
  };
};
